import React, { useState, useEffect } from 'react';
import { AlertTriangle, Mail, X } from 'lucide-react';

const AdminContactModal = ({ 
  isOpen = false, 
  errorDescription = '', 
  billId = '', 
  onClose = () => {} 
}) => {
  const [isVisible, setIsVisible] = useState(isOpen);

  useEffect(() => {
    setIsVisible(isOpen);
  }, [isOpen]);

  const handleClose = () => {
    setIsVisible(false);
    onClose();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100] p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full">
        {/* Header */}
        <div className="bg-red-50 dark:bg-red-900/20 border-b border-red-200 dark:border-red-800 p-4 flex items-start gap-3 rounded-t-lg">
          <AlertTriangle className="h-6 w-6 text-red-600 dark:text-red-400 flex-shrink-0 mt-0.5" />
          <div>
            <h2 className="text-lg font-bold text-red-800 dark:text-red-300">
              System Issue Detected
            </h2>
            <p className="text-sm text-red-700 dark:text-red-400 mt-1">
              An operation loop was terminated to protect your data.
            </p>
          </div>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          {/* Error Description */}
          <div className="bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3">
            <p className="text-xs font-mono text-gray-600 dark:text-gray-400 break-words">
              {errorDescription}
            </p>
            {billId && (
              <p className="text-xs text-gray-500 dark:text-gray-500 mt-2 pt-2 border-t border-gray-200 dark:border-gray-700">
                Affected Bill: <strong>{billId}</strong>
              </p>
            )}
          </div>

          {/* Admin Contact Info */}
          <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
            <p className="text-sm font-semibold text-blue-900 dark:text-blue-300 mb-2">
              Please Contact System Administrator:
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <span className="text-sm text-blue-800 dark:text-blue-400">
                  <strong>Michael Dziados</strong>
                </span>
              </div>
              <a
                href="mailto:mdziados@pengate.com"
                className="flex items-center gap-2 text-sm text-blue-600 dark:text-blue-400 hover:underline"
              >
                <Mail className="h-4 w-4" />
                mdziados@pengate.com
              </a>
            </div>
          </div>

          {/* Info Message */}
          <div className="text-xs text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-900 rounded p-3">
            <p>
              This error has been logged to the system database. You can close this dialog and try again, 
              but the operation will remain blocked for 30 seconds to prevent further loops.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 px-6 py-4 rounded-b-lg flex justify-end gap-3">
          <button
            onClick={handleClose}
            className="flex items-center gap-2 px-4 py-2 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-200 rounded-md transition-colors font-medium"
          >
            <X className="h-4 w-4" />
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminContactModal;
